import { Injectable } from '@angular/core';
import { WOW } from 'wowjs';
import { FilterService } from './shared/filter.service';
import { AppState } from './models/app.state';
import { Store } from '@ngrx/store';
import { IProductsState } from './reducers/product.reducer';
import { Observable } from "rxjs/Observable";
import { Filter, FilterType } from "./models/Filter";
import { LocationService } from "./shared/geolocation.service";
import { Router, NavigationEnd, NavigationStart } from "@angular/router";
import { IonRangeSliderComponent } from "ng2-ion-range-slider";
// import * as $ from 'jquery';

declare let $: any;

@Injectable()
export class JqueryHelperService {

  constructor(private filterService: FilterService,
    private store: Store<AppState>,
    private locationService: LocationService,
    private router: Router) {
  }

  // changeSlider(id: string) {
  //   this.initSliders(id);
  //   this.filterService.getActiveFilteres().subscribe((filters) => {
  //     if (filters.length > 0) {
  //       filters.map(a => {
  //         if (a.type == FilterType.PRICE) {
  //           // });
  //           // $('#slider-range_' + id).slider("option", "value", [minPrice, maxPrice]);
  //           $('#slider-range_' + id).slider("option", "values", [a.value['minPrice'], a.value['maxPrice']]);
  //           $('#amount_' + id).val('CHF ' + a.value['minPrice'] + ' - CHF ' + a.value['maxPrice']);
  //         }
  //         if (a.type == FilterType.GEO) {
  //           $('#slider-range_km_' + id).slider("option", "values", [0, a.value["radius"]]);
  //           $('#amount_km_' + id).val('km: ' + $('#slider-range_km_' + id).slider('values', 1));

  //         }
  //       });
  //     }
  //   });
  // }

  // updateslider(slider) {
  //   slider.update({ from: 10, to: 300 });

  //   // slider.update({ "disable": true });
  // }



  // initSliders(id: string) {
  //   const that = this;
  //   let maxDist = this.locationService.maxDistance ? this.locationService.maxDistance : 50;

  //   this.store.select('productsState')
  //     .subscribe((productsState: IProductsState) => {
  //       const minPrice = Math.floor(productsState.minPrice);
  //       const maxPrice = Math.floor(productsState.maxPrice);

  //       $('#amount_' + id).val('CHF ' + minPrice + ' - CHF ' + maxPrice);
  //       $('#slider-range_' + id).slider({
  //         range: true,
  //         min: minPrice,
  //         max: maxPrice,
  //         values: [minPrice, maxPrice],
  //         slide: (event, ui) => {
  //           const [min, max] = ui.values;
  //           $('#amount_' + id).val('CHF ' + min + ' - CHF ' + max);
  //           // ui.css('left', '-' + ui.value + 'px');
  //           that.filterService.addPriceFilter(min, max);
  //         },
  //       });
  //       const sliderRangeId = '#slider-range_km_' + id;
  //       $(sliderRangeId).slider({
  //         range: true,
  //         min: 0,
  //         max: maxDist,
  //         values: [0, maxDist],
  //         slide: function (event, ui) {
  //           const [, maxKm] = ui.values;

  //           $('#amount_km_' + id).val('km: ' + maxKm);
  //           that.filterService.addDistanceFilter(maxKm);
  //         }
  //       });
  //       $('#slider-range_km_' + id).find('.ui-slider-handle').first().remove();
  //       $('#amount_km_' + id).val('km: ' + $(sliderRangeId).slider('values', 1));

  //     });
  // }

  // initDistanceSlider(id: string) {
  //   const that = this;

  //   // this.store.select('productsState')
  //   //   .subscribe((productsState: IProductsState) => {
  //   //     if (this.locationService.userCoords) {
  //   //       const userLocationLongitude = this.locationService.userCoords.longitude;
  //   //       const userLocationLatitude = this.locationService.userCoords.latitude;
  //   //       //maxDist = Math.max.apply(Math, productsState.products.map(p => { return this.distance(userLocationLatitude, userLocationLongitude, p.location.latitude, p.location.longitude) }));
  //   //       // this.locationService.maxDistance = maxDist;
  //   //     }
  //   const sliderRangeId = '#slider-range_km_' + id;
  //   $(sliderRangeId).slider({
  //     range: true,
  //     min: 0,
  //     max: 50,
  //     values: [0, 50],
  //     slide: function (event, ui) {
  //       const [, maxKm] = ui.values;
  //       $('#amount_km_' + id).val('km: ' + maxKm);
  //       that.filterService.addDistanceFilter(maxKm);
  //     }
  //   });
  //   $('#slider-range_km_' + id).find('.ui-slider-handle').first().remove();
  //   $('#amount_km_' + id).val('km: ' + $(sliderRangeId).slider('values', 1));
  //   // });
  // }

  min = 0;
  max = 1;
  from = 0;
  to = 1;
  // someRange = [10, 100];
  selectedKm = 50;
  changeSliderData() {
    const that = this;
    this.store.select('productsState')
      .subscribe((productsState: IProductsState) => {
        const minPrice = Math.floor(productsState.minPrice);
        const maxPrice = Math.floor(productsState.maxPrice);
        this.min = this.from = minPrice;
        this.max = this.to = maxPrice;
      });
  }

  refreshPricefilter() {
    // elem.reset();
    // this.from = this.min;
    // this.to = this.max;
    this.sliderDesktop.update({ from: this.min, to: this.max });
    this.sliderMobile.update({ from: this.min, to: this.max });
  }

  refreshGeofilter() {
    this.kmSliderDesktop.update({ from: 50 }); this.kmSliderMobile.update({ from: 50 });
  }

  sliderDesktop; sliderMobile; kmSliderDesktop; kmSliderMobile;

  changeSlider2(rangeslider, singleslider, id) {
    if (id == 'desktop') {
      this.sliderDesktop = rangeslider;
      this.kmSliderDesktop = singleslider;
    } else {
      this.sliderMobile = rangeslider;
      this.kmSliderMobile = singleslider;
    }
    // let t = JSON.stringify(slider['el']['nativeElement']);
    this.changeSliderData();
    this.filterService.getActiveFilteres().subscribe((filters) => {
      if (filters.length > 0) {
        filters.map(a => {
          if (a.type == FilterType.PRICE) {
            this.from = a.value['minPrice'];
            this.to = a.value['maxPrice'];
            // slider.update({ from: a.value['minPrice'], to: a.value['maxPrice'] });
          }
          if (a.type == FilterType.GEO) {
            this.selectedKm = a.value["radius"];
            // slider.update({ from: a.value["radius"] });
          }
        });
      }
    }).unsubscribe();
  }

  onSliderChange(event, id) {
    id == 'desktop' ? this.sliderMobile.update({ from: event.from, to: event.to }) : this.sliderDesktop.update({ from: event.from, to: event.to });
    this.filterService.addPriceFilter(event.from, event.to);
  }

  onSingleSliderChange(event, id) {
    id == 'desktop' ? this.kmSliderMobile.update({ from: event.from }) : this.kmSliderDesktop.update({ from: event.from });
    this.filterService.addDistanceFilter(event.from);
  }

  // setCurrentScroll(id) {
  //   if (id == 'mobile') {
  //     var el = document.getElementById('overlay');
  //     var scrollDiff = el.scrollHeight - this.overlayScroll;
  //     el.scrollTop += scrollDiff;
  //   }
  // }

  test = () => {
    try {
      var el = document.getElementById('overlay');
      var scrollDiff = el.scrollHeight - this.overlayScroll;
      el.scrollTop += scrollDiff;
    } catch (err) { console.log('error', err) }
  }


  overlayTouchmove() {
    (function () {
      var _overlay = document.getElementById('overlay');
      var _clientY = null; // remember Y position on touch start

      _overlay.addEventListener('touchstart', function (event) {
        if (event.targetTouches.length === 1) {
          // detect single touch
          _clientY = event.targetTouches[0].clientY;
        }
      }, true);

      _overlay.addEventListener('touchmove', function (event) {
        if (event.targetTouches.length === 1) {
          // detect single touch
          disableRubberBand(event);
        }
      }, false);

      function disableRubberBand(event) {
        var clientY = event.targetTouches[0].clientY - _clientY;

        if (_overlay.scrollTop === 0 && clientY > 0) {
          // element is at the top of its scroll
          event.preventDefault();
        }

        if (isOverlayTotallyScrolled() && clientY < 0) {
          //element is at the top of its scroll
          event.preventDefault();
        }
      }

      function isOverlayTotallyScrolled() {
        return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
      }
    }())

    // document.body.addEventListener('touchmove', preventDefault, false);
    // document.addEventListener('touchmove', function (event) {
    //   event.preventDefault();
    // }, false);
  }

  // updatePriceText(from, to) {
  //   let text = 'CHF ' + from + ' - CHF ' + to;
  //   $('#amount_desktop').text(text);
  //   $('#amount_mobile').text(text);
  // }

  sliderStep() {
    $(document).on("pagecreate", function () {
      $("#slider-step").on("slidestart slidestop", function (event) {
        // console.log(event.type + " - " + $(this).val());
      });
    });
  }

  onGeoSliderChange(event) {
    this.filterService.addDistanceFilter(event);
  }

  distance(lat1, lon1, lat2, lon2) {
    var radlat1 = Math.PI * lat1 / 180
    var radlat2 = Math.PI * lat2 / 180
    var radlon1 = Math.PI * lon1 / 180
    var radlon2 = Math.PI * lon2 / 180
    var theta = lon1 - lon2
    var radtheta = Math.PI * theta / 180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    dist = dist * 1.609344;
    // if (unit == "N") { dist = dist * 0.8684 }
    return dist
  }

  onImgLoad() {
    $('#loader_img').show();
    $('.mobile-img').on('load', function () {
      // hide/remove the loading image
      $('#loader_img').fadeOut();
    });
  }

  initMeanMenu() {
    $('.mobile-menu nav').meanmenu({
      meanMenuContainer: '.mobile-menu-area',
      meanScreenWidth: '991',
      meanRevealPosition: 'right',
    });


    $('.search__open').on('click', function () {
      $('body').addClass('search__box__show__hide');
      return false;
    });

    $('.search__close__btn .search__close__btn_icon').on('click', function () {
      $('body').removeClass('search__box__show__hide');
      return false;
    });

  }


  resetSearchInput() {
    $('.searchInput').val('');
  }

  // loadIMGS() {
  //   $(function ($) {
  //     $(".lazy").Lazy({
  //       // scrollDirection: 'vertical',
  //       // effect: 'fadeIn',
  //       // visibleOnly: true,
  //       // effect: "fadeIn",
  //       // effectTime: 2000,
  //       // threshold: 0,
  //       combined: true,
  //       delay: 2000,
  //       beforeLoad: function (element) {
  //         console.log('ready to load', element.data('src'));
  //       },
  //       afterLoad: function (element) {
  //         console.log('loaded:', element);
  //       },
  //       onError: function (element) {
  //         console.log("error:", element);
  //       },
  //       onFinishedAll: function () {
  //         console.log('loaded all images');
  //       }
  //     });
  //   });
  // }

  portfolioMasonry() {
    $('.htc__product__container').imagesLoaded(() => {
      // init Isotope
      const $grid = $('.product__list').isotope({
        itemSelector: '.single__pro',
        percentPosition: true,
        transitionDuration: '0.7s',
        layoutMode: 'fitRows',
        masonry: {
          // use outer width of grid-sizer for columnWidth
          columnWidth: 1,
        }
      });

    });
    $('.product__menu button').on('click', (event) => {
      $(this).siblings('.is-checked').removeClass('is-checked');
      $(this).addClass('is-checked');
      event.preventDefault();
    });
  }

  stickyHeader() {
    const win = $(window);
    const sticky_id = $('#sticky-header-with-topbar');
    win.on('scroll', () => {
      const scroll = win.scrollTop();
      if (scroll < 245) {
        sticky_id.removeClass('scroll-header');
      } else {
        sticky_id.addClass('scroll-header');
      }
    });
  }

  isMenuOpen(isOpen: boolean) {
    if (isOpen && window.innerWidth <= 991) {
      this.disableScroll();
    } else {
      this.enableScroll();
    }
  }

  onwindowResize() {
    let that = this;
    $(window).resize(function () {
      if ($(".menu-open")[0] && window.innerWidth <= 991) {
        that.disableScroll();
      } else {
        that.enableScroll();
      }
    });
  }

  disableScroll() {
    $("html").addClass('overflowHidden');
    $("body").addClass('overflowHidden');
  }
  enableScroll() {
    $("html").removeClass('overflowHidden');
    $("body").removeClass('overflowHidden');
  }

  scrollUp() {
    $.scrollUp({
      scrollText: '<i class="zmdi zmdi-chevron-up"></i>',
      easingType: 'linear',
      scrollSpeed: 50,
      animation: 'fade'
    });
  }

  tooltip() {
    $('[data-toggle="tooltip"]').tooltip({
      animated: 'fade',
      placement: 'top',
      container: 'body',
      content: "Awesome title!"
    });
  }

  scrollRevealJsInit() {
    // window.sr = ScrollReveal({ duration: 800 , reset: true });
  }

  initMobileMenu() {
    $(".button a").click(function () {
      $(".overlay").fadeToggle(200);
      $(this).toggleClass('btn-open').toggleClass('btn-close');
    });
    // $(".logo-mobile a").click(function () {
    //   $(".overlay").fadeToggle(200);
    //   $(this).toggleClass('btn-open').toggleClass('btn-close');
    // });
    //
    // $('.overlay').on('click', function(){
    //   $(".overlay").fadeToggle(200);
    //   $(".button a").toggleClass('btn-open').toggleClass('btn-close');
    // });
  }

  overlayScroll: number;
  onPageScroll() {
    const div = $("#overlay");
    const sticky_id = $('.nav-logo');
    div.on('scroll', () => {
      this.overlayScroll = document.getElementById('overlay').scrollHeight;

      const scroll = div.scrollTop();
      if (scroll > 0) {
        $(".nav-logo").addClass("box-shadow-bottom");
      } else {
        $(".nav-logo").removeClass("box-shadow-bottom");
      }
    });
  }

  scrollPos; windowScrollPos;
  saveScrollPosition() {
    // let fixmeTop = $('image-zoom-container').scrollTop();
    // console.log(fixmeTop);

    this.scrollPos = 0;
    $(window).on('scroll', () => {
      var instance = $(".xzoom").data('xzoom');
      if (instance) {
        if (window.scrollY > 151) {
          instance.options.Yoffset = window.scrollY - 150;
        } else {
          instance.options.Yoffset = 0;
        }
      }

      if (this.router.url.includes("/home")) {
        this.scrollPos = window.scrollY;
      }
      if (this.router.url.includes("/windows")) {
        this.windowScrollPos = window.scrollY;
      }
    });
  }

  initZoom(isWindow: boolean = false) {
    let pos = isWindow ? "left" : "right";

    // let zoomwidth = "auto";
    let zoomwidth = isWindow ? 900 : "auto";
    $('.xzoom, .xzoom-gallery').xzoom({ lensCollision: true, zoomWidth: zoomwidth, zoomHeight: zoomwidth, position: pos, tint: '#333', smoothScale: 2, adaptive: true });

    // var instance = $(".xzoom").data('xzoom');
    this.resetZoom(isWindow);
    // zoomWidth: 400, zoomHeight: 400,defaultScale: -1

    // var instance = $(".xzoom").data('xzoom');

    // instance.options.zoomWidth = 270;
    // instance.options.zoomHeight = 270;
    // instance.options.lensCollision = true;
    // instance.options.position = pos;
    // instance.options.tint = '#333';
    // instance.options.smoothScale = 2;

    // let mainImg = new Image();
    // mainImg.src = $('.main-imgg').attr('src');
    // mainImg.onload = () => {
    //   if (mainImg.width < 400)
    //     width = mainImg.width - 50;

    //   this.initXZoom(width, pos);

    // };

    // instance.eventscroll = function (element) {
    //   element.bind('mousewheel DOMMouseScroll', instance.xscroll);

    //   // element.bind('click', function(event) {
    //   //   $('#main_image').trigger('click');
    //   // });

    //   $('.xzoom').xzoom();
    // }

    //Example: Integration with "Magnific Popup" plugin
    // $('.main-imgg').bind('click', function () {
    //   var xzoom = $(this).data('xzoom');
    //   // xzoom.closezoom();

    //   // var gallery = xzoom.gallery().cgallery;
    //   // var i, images = new Array();
    //   // for (i in gallery) {
    //   //   images[i] = { src: gallery[i] };
    //   // }
    //   // $.magnificPopup.open({ items: images, type: 'image', gallery: { enabled: true } });

    //   // xzoom.openzoom(event);
    //   xzoom.eventdefault()

    //   event.preventDefault();
    // });
  }

  // clicktest() {

  //   $('.xzoom').data("xzoom").destroy();

  // }
  // i = 0;

  resetZoom(isWindow: boolean = false) {

    this.removeZoom();

    let mainImg = new Image();
    mainImg.src = $('.main-imgg').attr('src');
    mainImg.onload = () => {
      // $('.main-imgg').attr('width', mainImg.width);
      $(".main-imgg").css({
        width: '100% !important'
      })
      this.onMainImageHover();

      if (mainImg.width < 300 || window.innerWidth < 900) {
        var instance = $(".xzoom").data('xzoom');
        if (instance)
          instance.eventunbind();

      } else {
        if ($('.xzoom').data("xzoom")) { $('.xzoom').data("xzoom").destroy() }

        let $element = $(".xzoom");
        if ($element) { $.removeData($element.get(0)) }

        let pos = isWindow ? "left" : "right";
        // let zoomwidth = "auto";
        let zoomwidth = isWindow ? 900 : "auto";
        $('.xzoom, .xzoom-gallery').xzoom({ lensCollision: true, zoomWidth: zoomwidth, zoomHeight: zoomwidth, position: pos, tint: '#333', smoothScale: 2 });
      }

      // width = mainImg.width - 50;

    };

    // if (this.i % 2 == 0) {
    //   var instance = $(".xzoom").data('xzoom');
    //   if (instance)
    //     instance.eventunbind();

    // } else {
    //   let $element = $(".xzoom");
    //   $.removeData($element.get(0));

    //   let pos = isWindow ? "left" : "right";
    //   $('.xzoom, .xzoom-gallery').xzoom({ lensCollision: true, zoomWidth: 270, zoomHeight: 270, position: pos, tint: '#333', smoothScale: 2 });
    //   this.onMainImageHover();
    // }

    // // instance.eventdefault()
  }

  removeZoom() {
    if ($('.xzoom-source')) {
      $(".xzoom-source").remove()
      $(".xzoom-preview").remove()
    }
  }

  onMainImageHover() {
    $(".portfolio-full-image").on("mouseover", function () {
      $(".main-imgg").css({
        width: '100%'
      })

      // if ($('.xzoom-source').length > 1) {
      //   $(".xzoom-source").first().remove()
      //   $(".xzoom-preview").first().remove()
      // }
    });
  }
  onMainImageLeave() {
    // $(".main-imgg").on("mouseleave", function () {
    $(".product__small__images").on("mouseover", function () {
      // $(".main-imgg").css({
      //   width: '100%'
      // })
      if ($('.xzoom-source')) {
        $(".xzoom-source").first().remove()
        $(".xzoom-preview").first().remove()
      }
    });
  }

  // initXZoom(width, pos) {
  //   // zoomWidth: width, zoomHeight: width, 
  //   $('.xzoom, .xzoom-gallery').xzoom({ lensCollision: true, zoomWidth: 400, zoomHeight: 400, position: pos, tint: '#333', smoothScale: 2 });

  //   var instance = $(".xzoom").data('xzoom');
  //   // instance.options.zoomWidth = width;
  //   // instance.options.zoomHeight = width;

  // }

  // opacity() {
  //   $('.main-imgg').css({
  //     opacity: 0,
  //   });
  //   setTimeout(() => {
  //     $('.main-imgg').css({
  //       opacity: 1,
  //     });
  //   }, 200);
  // }

  // t = 0;
  setImage(img) {
    // let mainimg = document.querySelector(".main-imgg");
    // if (this.t < 2) {
    // mainimg.setAttribute("xoriginal", img);
    $(".main-imgg").attr("xoriginal", img);
    // }
    // this.t++;
    // $(".main-imgg").attr("xoriginal", img);
  }

  // zoomDiv() {
  //   if (window.scrollY > 151) {
  //     // $('image-zoom-container').css({
  //     //   position: 'fixed',
  //     //   // left: '959px !important'
  //     // });
  //     $(".xzoom").xzoom('option', 'Yoffset', window.scrollY);
  //     var instance = $(".xzoom").data('xzoom');


  //   } else {
  //     // $('image-zoom-container').css({
  //     //   position: 'absolute',
  //     //   // left: '611px'
  //     // });
  //     $(".xzoom").xzoom('option', 'Yoffset', 0);
  //   }
  //   //   let fixmeTop = $('image-zoom-container').scrollTop();

  //   //   $(window).on('scroll', () => {
  //   //     var currentScroll = $(window).scrollTop();
  //   //     if (currentScroll >= fixmeTop) {
  //   //       $('.fixme').css({
  //   //         position: 'fixed',
  //   //         top: '0',
  //   //         left: '0'
  //   //       });
  //   //     } else {
  //   //       $('.fixme').css({
  //   //         position: 'absolute'
  //   //       });
  //   //     }
  //   //   });
  // }
  flag = false;
  setScrollPosition() {
    if (this.flag) {
      // setTimeout(() => {
      window.scrollTo(0, this.scrollPos);
      // });
    }

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        if (val.url.includes("/home") && this.scrollPos) {
          this.flag = true;
          setTimeout(() => {
            window.scrollTo(0, this.scrollPos);
          }, 90);
        } else if (val.url.includes("/windows") && this.windowScrollPos) {
          setTimeout(() => {
            window.scrollTo(0, this.windowScrollPos);
          }, 90);
        } else {
          this.scrollToTop();
        }
      }
    });
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  fixedFooterbottomscript() {
    const $newsletter_height = $('.htc__foooter__area');
    $('.fixed__footer').css({ 'margin-bottom': $newsletter_height.height() + 'px' });
  }

  // searchBar() {
  //   $('.search__open').on('click', function () {
  //     $('body').toggleClass('search__box__show__hide');
  //     return false;
  //   });
  //
  //   $('.search__close__btn .search__close__btn_icon').on('click', function () {
  //     $('body').toggleClass('search__box__show__hide');
  //     return false;
  //   });
  // }

  toogleMenu() {
    $('.toggle__menu').on('click', function () {
      $('.offsetmenu').addClass('offsetmenu__on');
      $('.body__overlay').addClass('is-visible');

    });

    $('.offsetmenu__close__btn').on('click', function () {
      $('.offsetmenu').removeClass('offsetmenu__on');
      $('.body__overlay').removeClass('is-visible');
    });
  }

  shoppingCartArea() {
    $('.cart__menu').on('click', function () {
      $('.shopping__cart').addClass('shopping__cart__on');
      $('.body__overlay').addClass('is-visible');

    });

    $('.offsetmenu__close__btn').on('click', function () {
      $('.shopping__cart').removeClass('shopping__cart__on');
      $('.body__overlay').removeClass('is-visible');
    });
  }

  filterArea() {
    $('.filter__menu').on('click', function () {
      $('.filter__wrap').addClass('filter__menu__on');
      $('.body__overlay').addClass('is-visible');

    });

    $('.filter__menu__close__btn').on('click', function () {
      $('.filter__wrap').removeClass('filter__menu__on');
      $('.body__overlay').removeClass('is-visible');
    });
  }

  userMenu() {
    $('.user__menu').on('click', function () {
      $('.user__meta').addClass('user__meta__on');
      $('.body__overlay').addClass('is-visible');

    });

    $('.offsetmenu__close__btn').on('click', function () {
      $('.user__meta').removeClass('user__meta__on');
      $('.body__overlay').removeClass('is-visible');
    });
  }

  overlayClose() {
    $('.body__overlay').on('click', function () {
      $(this).removeClass('is-visible');
      $('.offsetmenu').removeClass('offsetmenu__on');
      $('.shopping__cart').removeClass('shopping__cart__on');
      $('.filter__wrap').removeClass('filter__menu__on');
      $('.user__meta').removeClass('user__meta__on');
    });
  }

  homeSlider() {
    if ($('.slider__activation__wrap').length) {
      $('.slider__activation__wrap').owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        autoplay: false,
        navText: ['<i class="zmdi zmdi-chevron-left"></i>', '<i class="zmdi zmdi-chevron-right"></i>'],
        autoplayTimeout: 10000,
        items: 1,
        dots: false,
        lazyLoad: true,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 1
          },
          800: {
            items: 1
          },
          1024: {
            items: 1
          },
          1200: {
            items: 1
          },
          1400: {
            items: 1
          },
          1920: {
            items: 1
          }
        }
      });
    }
  }

  popularProductWrap() {
    $('.popular__product__wrap').owlCarousel({
      loop: true,
      margin: 0,
      nav: true,
      autoplay: false,
      navText: ['<i class="zmdi zmdi-chevron-left"></i>', '<i class="zmdi zmdi-chevron-right"></i>'],
      autoplayTimeout: 10000,
      items: 3,
      dots: false,
      lazyLoad: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 2
        },
        800: {
          items: 2
        },
        1024: {
          items: 3
        },
        1200: {
          items: 3
        },
        1400: {
          items: 3
        },
        1920: {
          items: 3
        }
      }
    });
  }

  testimonialWrap() {
    $('.testimonial__wrap').owlCarousel({
      loop: true,
      margin: 0,
      nav: false,
      autoplay: false,
      navText: false,
      autoplayTimeout: 10000,
      items: 1,
      dots: false,
      lazyLoad: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        800: {
          items: 1
        },
        1024: {
          items: 1
        },
        1200: {
          items: 1
        },
        1400: {
          items: 1
        },
        1920: {
          items: 1
        }
      }
    });
  }

  magnificPopup() {
    $('.video-popup').magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      zoom: {
        enabled: true,
      }
    });

    $('.image-popup').magnificPopup({
      type: 'image',
      mainClass: 'mfp-fade',
      removalDelay: 100,
      gallery: {
        enabled: true,
      }
    });
  }

  priceSliderActive() {
    $('#slider-range').slider({
      range: true,
      min: 10,
      max: 500,
      values: [110, 400],
      slide: function (event, ui) {
        $('#amount').val('$' + ui.values[0] + ' - $' + ui.values[1]);
      }
    });
    $('#amount').val('$' + $('#slider-range').slider('values', 0) +
      ' - $' + $('#slider-range').slider('values', 1));
  }

  plusMinusButton() {
    $('.cart-plus-minus').append('<div class="dec qtybutton">-</i></div><div class="inc qtybutton">+</div>');

    $('.qtybutton').on('click', function () {
      var $button = $(this);
      var oldValue = $button.parent().find('input').val();
      if ($button.text() === '+') {
        var newVal = parseFloat(oldValue) + 1;
      } else {
        // Don't allow decrementing below zero
        if (oldValue > 1) {
          newVal = parseFloat(oldValue) - 1;
        } else {
          newVal = 1;
        }
      }
      $button.parent().find('input').val(newVal);
    });


  }

  jQueryScrollNav() {
    $('.onepage--menu').onePageNav({
      scrollOffset: 0
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/jquery-helper.service.ts